<template>
    <section>
        <m-table-list ref="tableList" :fetch-list-func="fetchListFunc" :search-form.sync="filters">
            <template v-slot:search-items>
                <m-search-panel @searchBoxChange="handleSearch" isShowOpenButton @keyup.enter.native="handleSearch()">
                    <div slot="title">快速筛选</div>
                    <div class="filters">
                        <div class="query-item-all">
                            <div class="filter-item">
                                <div class="demonstration">菜单编码</div>
                                <el-input v-model="filters.serverCode" placeholder="菜单编码"></el-input>
                            </div>
                            <div class="filter-item">
                                <div class="demonstration">菜单名称</div>
                                <el-input v-model="filters.menuName" placeholder="菜单名称"></el-input>
                            </div>
                              <div class="filter-item">
                            <div class="demonstration">是否启用</div>
                            <el-select v-model="filters.status" placeholder="--未选择--">
                                <el-option value="" label="不限"></el-option>
                                <el-option value="Enable" label="是" />
                                <el-option value="Disable" label="否" />
                            </el-select>
                        </div>

                            
                        </div>
                        <div class="filter-item buttons">
                            <!-- <el-button class="reset-btn" @click="$router.push({name: 'privilege.menu.details'})">新建</el-button> -->
                          <el-button type="primary" size="small" class="query-btn" @click="handleSearch">查询</el-button>
                          <el-button type="primary" size="small" plain @click="handleClearSearchForm">重置</el-button>
                        </div>
                    </div>
                </m-search-panel>
            </template>
             <template v-slot:page-title>
                <div class="page-tabe-title">
                    <div class="right">
                        <span class="line"></span>
                        <div>数据列表</div>
                    </div>
                    <div class="left">
                         <el-button type="primary" size="small" class="add-btn" @click="$router.push({name: 'privilege.menu.details'})">+添加</el-button>
                    </div>
                </div>
            </template>
            <template v-slot:table-columns>
                <el-table-column label="名称" prop="menuName" ></el-table-column>
                <el-table-column label="创建时间" prop="created"  width="150px">
                    <template slot-scope="{row}">{{row.created | dateTime('yyyy-MM-dd hh:mm')}}</template>
                </el-table-column>
                <el-table-column label="排序" prop="orderId" width="120px"></el-table-column>
                <el-table-column label="是否菜单展示" prop="showInMenu" width="150px" align="center">
                    <template slot-scope="{row}">{{row.showInMenu | boolTxt}}</template>
                </el-table-column>
                 <el-table-column label="是否启用" prop="status" width="150px" align="center">
                    <template slot-scope="{row}">
                        <el-switch   :value="row.status == 'Enable' ? true :false" active-color="#13ce66" inactive-color="#ff4949" @change="updateStatus(row)"></el-switch>
                    </template>
                </el-table-column>
                 
                <!-- <el-table-column label="URL" prop="menuUrl"></el-table-column> -->
                
                <el-table-column label="操作" width="140px">
                    <template slot-scope="{row}">
                        <el-button @click="$router.push({name: 'privilege.menu.details', query: { id: row.id }})" type="text" size="small">编辑</el-button>
                        <el-button @click="deleteRow(row.id)" type="text" size="small" style="color: #f56c6c;">删除</el-button>
                    </template>
                </el-table-column>
            </template>
        </m-table-list>
    </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";

export default {
    name: "privilege.menu.list",
    data() {
        return {
            filters: {
                pageNo: 1,
                pageSize: 10,
                serverCode: "",
                menuName: "",
                showInMenu:"",
                status:"",
            },
            time: "",
        };
    },
    components: {
        "m-table-list": tableList,
    },
    created() {},
    methods: {
       
        handleSearch() {
            this.$refs.tableList.handleSearch();
            // this.$refs.tableList.getMainData();
        },
        handleClearSearchForm() {
            this.$refs.tableList.resetSearchForm();
        },
        fetchListFunc: api.manage.getMenuInfoList,
        // fetchListFunc() {},
        updateStatus(item){
            let newStatus = item.status;
            this.$confirm(`是否${newStatus == 'Enable' ? '关闭':'启用'}`, "提示", {
                confirmButtonText: "确定",
              confirmButtonClass:'confirmBtn',
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                api.manage.setMenuStatus({menuIds:[item.id],status:newStatus == 'Enable' ? 'Disable':'Enable'}).then(() => {
                    this.$message.success(`${newStatus == 'Enable' ? '关闭':'启用'}成功`);
                    this.$refs.tableList.getMainData();
                });
            });
        },
        deleteRow(id) {
            this.$confirm("是否删除", "提示", {
                confirmButtonText: "确定",
              confirmButtonClass:'confirmBtn',
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                api.manage.deleteMenu({id}).then(() => {
                    this.$message.success("删除成功");
                    this.$refs.tableList.getMainData();
                });
            });
        },
    },
};
</script>
